import * as styles from './Skeleton.module.css'

function Skeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.avatar}></div>
      <div className={styles.content}></div>
    </div>
  )
}

export default Skeleton
